const fromdata = [{
		inputdata: "",
		title: "产品线",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请选择",
		types: "",
		inputtype: "select",
		pt: true,
		width: "350px",
		lablewith: "120px",
		btx: false,
		options: [],
		event: "invClass",
	},
	{
		inputdata: "",
		title: "LEVEL2",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请选择",
		types: "",
		inputtype: "select",
		pt: true,
		width: "350px",
		lablewith: "120px",
		btx: false,
		options: [],
		event: "LEVEL2",
	},
	{
		inputdata: "",
		title: "LEVEL3",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请选择",
		types: "",
		inputtype: "select",
		pt: true,
		width: "350px",
		lablewith: "120px",
		btx: false,
		options: [],
		event: "change",
	},
	{
		inputdata: "",
		title: "启效/有效",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请选择",
		types: "date",
		inputtype: "dateSection",
		pt: true,
		widthLeft: 155,
		heightLeft: 32,
		widthRight: 155,
		heightRight: 32,
		width: "340px",
		lablewith: "120px",
		btx: false,
	},
	{
		inputdata: "",
		title: "最小数量（含）",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "number",
		inputtype: "input",
		pt: true,
		width: "340px",
		lablewith: "120px",
		btx: false,
	},
	{
		inputdata: "",
		title: "最大数量（不含）",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "number",
		inputtype: "input",
		pt: true,
		width: "340px",
		lablewith: "120px",
		btx: false,
	},
	{
		inputdata: "",
		title: "系数",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "number",
		inputtype: "input",
		pt: true,
		width: "340px",
		lablewith: "120px",
		btx: false,
	}
];
export default fromdata;